export * from './acordeon-container';
export * from './acordeon-item';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/acordeon/index.ts